module.exports = __webpack_public_path__ + "img/CND.c6e9681e.svg";